<template>
    <el-tooltip :content="tooltipText" placement="bottom">
        <p class="data-comparison fs-3 gray-60">
            <span :class="getColor(stats.color)">
                <span class="numbers-diff__icon-and-percent">
                    <CompassIcon :icon="stats.iconClasses" />
                    {{ stats.percent ? stats.percent + '%' : $l10n.__('N/A') }}
                </span>
                <span>{{ stats.comparison }}</span>
            </span>
        </p>
    </el-tooltip>
</template>

<script>
const { format, apply } = require('@sellsy/numberformat');

export default {
    props: {
        tooltipText: {
            type: String,
            required: false,
            default: false,
        },
        amount: {
            type: Number,
            required: true,
            default: 0,
        },
        comparison: {
            type: Number,
            required: true,
            default: 0,
        },
        currencySymbol: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            positive: {
                color: 'success',
                iconClasses: 'caret-up-fill',
            },
            negative: {
                color: 'danger',
                iconClasses: 'caret-down-fill',
                percent: '- 100',
            },
            neutral: {
                color: 'neutral',
                iconClasses: 'caret-right-fill',
            },
        };
    },
    computed: {
        stats() {
            const corpNumberFormat = this.$store.state['corp']['numformat'];

            const numberFormatConfig = {
                currency: this.currencySymbol,
                currencypos: corpNumberFormat.currencypos,
                decimals: corpNumberFormat.decimals,
                thousands: corpNumberFormat.thousands,
                precision: corpNumberFormat.precision,
            };

            const amount = this.amount - this.comparison;
            const comparison = apply(Math.abs(amount), numberFormatConfig);

            if (this.comparison == 0 && this.amount > 0) {
                this.positive.comparison = '+ ' + comparison;
                this.positive.percent = false;
                return this.positive;
            }

            //prevent division by 0
            if (this.comparison != 0) {
                //( ( initialValue - newValue ) / initialValue ) x 100
                var percent = format(
                    Math.abs((this.amount - this.comparison) / this.comparison) * 100,
                    numberFormatConfig,
                );
            } else {
                var percent = format(0, numberFormatConfig);
            }

            if (amount > 0) {
                this.positive.percent = '+ ' + percent;
                this.positive.comparison = '+ ' + comparison;
                return this.positive;
            } else if (amount < 0) {
                this.negative.percent = '- ' + percent;
                this.negative.comparison = '- ' + comparison;
                return this.negative;
            } else {
                this.neutral.comparison = '+ ' + comparison;
                this.neutral.percent = '+ ' + percent;
                return this.neutral;
            }
        },
    },
    methods: {
        getColor(color) {
            let colorClass;
            switch (color) {
                case 'success':
                    colorClass = 'numbers-diff--success';
                    break;
                case 'danger':
                    colorClass = 'numbers-diff--danger';
                    break;
                case 'neutral':
                default:
                    colorClass = 'numbers-diff--neutral';
                    break;
            }
            return ['numbers-diff', colorClass];
        },
    },
};
</script>

<style lang="scss" scoped>
.numbers-diff {
    display: flex;
    align-items: center;
    gap: var(--spacing-3);

    &__icon-and-percent {
        display: flex;
        align-items: center;
        gap: var(--spacing-0);
    }

    &--success {
        color: var(--colors-common-text-success-default);
    }
    &--danger {
        color: var(--colors-common-text-alert-default);
    }
    &--neutral {
        color: var(--colors-common-text-standard-caption);
    }
}
</style>
